import APIClient from '@/shared/http/clients/api'

const resourceName = 'parcelas'
const APICore = process.env.APIBaseURLCore

/**
 * Repository para Parcelas Detalhadas
 * Melhoria 8.697 - Discriminação por Parcela
 */

/**
 * Busca todas as parcelas de um CardProduto específico
 * @param {Number} cardProdutoId - ID do CardProduto
 */
const getParcelasByCardProduto = (cardProdutoId, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/card-produto/${cardProdutoId}`, config)

/**
 * Busca apenas parcelas em atraso de um CardProduto
 * @param {Number} cardProdutoId - ID do CardProduto
 */
const getParcelasEmAtrasoByCardProduto = (cardProdutoId, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/card-produto/${cardProdutoId}/em-atraso`, config)

/**
 * Busca uma parcela específica por ID
 * @param {Number} id - ID da parcela
 */
const getParcelaById = (id, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/${id}`, config)

const ParcelaRepository = {
  getParcelasByCardProduto,
  getParcelasEmAtrasoByCardProduto,
  getParcelaById
}

export default ParcelaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/parcela/ParcelaRepository.js